export default "__VITE_ASSET__DmUo9mx2__"